export interface JobPaginatedResponse<T> {
    pageNumber: number;
    pageSize: number;
    totalResults: number;
    items: T[];
}
